export default __webpack_public_path__ + "static/media/startpic2.9c536125.jpg";